import { mapApiReportKeyToType } from "../reportKeys";

const BALANCE_TYPES = new Set(["verticalBalance", "horizontalBalance"]);
const INCOME_TYPES = new Set([
  "verticalIncome",
  "advancedProfitability",
  "costAnalysis",
  "breakEven",
]);
const CASH_FLOW_TYPES = new Set(["cashFlow"]);
const TREND_TYPES = new Set([
  "trend",
  "forecasting",
  "variance",
  "correlation",
  "volatility",
  "sensitivity",
]);
const RATIO_TYPES = new Set([
  "workingCapital",
  "liquidity",
  "solvency",
  "activity",
  "profitability",
  "efficiency",
  "expense",
  "dupont",
  "earningsQuality",
  "receivables",
  "payables",
  "ccc",
  "financialStability",
  "earningsStability",
]);
const AGING_TYPES = new Set(["receivables", "payables"]);

const LIQUIDITY_TREE_TYPES = new Set(["workingCapital", "liquidity"]);

export const resolveReportKind = (reportType, financialData = {}) => {
  const actualType = mapApiReportKeyToType(reportType);

  // Working-capital/liquidity handlers ship originalData as { balanceSheet, cashFlow }
  // raw Wafeq trees; the generic "ratios" flattener cannot descend into those arrays,
  // so they get a dedicated kind with tree-aware extraction.
  if (LIQUIDITY_TREE_TYPES.has(actualType) && Array.isArray(financialData?.balanceSheet?.rows)) {
    return "liquidity";
  }

  if (BALANCE_TYPES.has(actualType)) return "balance_sheet";
  if (INCOME_TYPES.has(actualType)) return "income_statement";
  if (CASH_FLOW_TYPES.has(actualType)) return "cash_flow";
  if (TREND_TYPES.has(actualType)) return "trend";
  if (AGING_TYPES.has(actualType)) return "aging";
  if (RATIO_TYPES.has(actualType)) return "ratios";

  if (Array.isArray(financialData?.rows) && Array.isArray(financialData?.columns)) {
    return financialData.columns.length > 1 ? "trend" : "balance_sheet";
  }

  if (financialData?.balanceSheet || financialData?.profitAndLoss || financialData?.cashFlow) {
    return "custom";
  }

  if (financialData?.ratios || financialData?.metrics) {
    return "ratios";
  }

  return "custom";
};
